import React from 'react';
import styles from './TextAreaInput.module.scss';
import { useCallback } from 'react';

function TextAreaInput(props) {
    const { className = '', onChange, ...otherProps } = props;

    const handleChange = useCallback(
        (e) => {
            const value = e.currentTarget.value;

            if (onChange) onChange(value);
        },
        [onChange]
    );

    return <textarea className={[className, styles.TextAreaInput].join(' ')} onChange={handleChange} {...otherProps} />;
}

export default TextAreaInput;
